// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export const fallbackItemHeight = 31;



// WEBPACK FOOTER //
// /local/home/vibhorbh/workplace/src/select/parts/common.ts